/* eslint-disable no-unused-vars */
/**
 * Front-end JavaScript
 *
 * The JavaScript code you place here will be processed by esbuild. The output
 * file will be created at `../theme/js/script.min.js` and enqueued in
 * `../theme/functions.php`.
 *
 * For esbuild documentation, please see:
 * https://esbuild.github.io/
 */

function addBodyClassOnScroll() {
	var scrollTop =
		window.pageYOffset ||
		(document.documentElement || document.body.parentNode || document.body)
			.scrollTop;

	// Check if the page has been scrolled more than 50px
	if (scrollTop > 50) {
		// Add a class to the body
		document.body.classList.add('scrolled');
	} else {
		// Remove the class if less than 50px
		document.body.classList.remove('scrolled');
	}
}

// Listen for the scroll event
window.addEventListener('scroll', addBodyClassOnScroll);

document
	.querySelectorAll('.product-details-section__trigger')
	.forEach((trigger) => {
		trigger.addEventListener('click', () => {
			trigger.parentElement.classList.toggle('active');
		});
	});

document.getElementById('menu-open').addEventListener('click', () => {
	document.getElementById('mobile-menu').classList.add('flex');
	document.getElementById('mobile-menu').classList.remove('hidden');
});

document.getElementById('menu-close').addEventListener('click', () => {
	document.getElementById('mobile-menu').classList.add('hidden');
	document.getElementById('mobile-menu').classList.remove('flex');
});

document.querySelectorAll('.faq-item__question').forEach((trigger) => {
	trigger.addEventListener('click', () => {
		trigger.parentElement.classList.toggle('active');
	});
});

// Contact modal
const openContactModal = () => {
	const contactModalEl = document.getElementById('contact-modal');
	if (!contactModalEl) return;

	contactModalEl.classList.add('flex');
	contactModalEl.classList.remove('hidden');
	document.body.style.overflowY = 'hidden';

}

document.querySelectorAll('.menu-item-type-custom').forEach((item) => {
	if (item.querySelector('a').innerText.toLowerCase().includes('contact')) {
		item.addEventListener('click', (e) => {
			e.preventDefault();

			openContactModal();
		});
	}
});

// Open Contact Modal from sections (Dealers Section)
const sectionOpenModalBtns = document.querySelectorAll('.val-open-modal__btn');
if (sectionOpenModalBtns.length !== 0) {
	sectionOpenModalBtns.forEach((btn) => {
		btn.addEventListener('click', () => {
			openContactModal();
		});
	});
}

document.getElementById('contact-modal-close').addEventListener('click', () => {
	document.getElementById('contact-modal').classList.add('hidden');
	document.getElementById('contact-modal').classList.remove('flex');
	document.body.style.overflowY = 'auto';
});

const faqContactButton = document.getElementById('faq-contact-button');

if (faqContactButton) {
	faqContactButton.addEventListener('click', (e) => {
		e.preventDefault();
		document.getElementById('contact-modal').classList.add('flex');
		document.getElementById('contact-modal').classList.remove('hidden');
		document.body.style.overflowY = 'hidden';
	});
}
